import React, { Component } from "react";
import { Button, Form, Modal, Row } from "antd";
import CloseIcon from "../../../../assets/fi_x-circle.svg";
import "./InfoModal.css";
import { injectIntl } from "react-intl";

class InfoModal extends Component {
  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
    } = this.props;

    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="info-modal"
      >
        <Form>
          <div
            className="info-modal-title"
          >
            {intl.formatMessage({id: "plan-update-pending-title"})}
          </div>
          <p className="info-modal-label">
          {intl.formatMessage({id: "plan-update-pending-content"})}
        </p>

        </Form>
        <br/>
        <br/>
        <Row type={"flex"} justify={"end"}>
          <Button
            size={"large"}
            type={"primary"}
            onClick={handleHiddenModal}
            className="info-modal-button accept"
          >
            {intl.formatMessage({ id: "accept" })}
          </Button>
        </Row>
      </Modal>
    );
  }
}

export default injectIntl(InfoModal);